/**
 * Self-reported average monthly GMV bands across all of a prospect's channels.
 * Keep in sync with MarketingContact::MONTHLY_GMV_RANGE_LABELS (app/models/marketing_contact.rb) —
 * the API validates the submitted value against that list.
 */
export const MONTHLY_GMV_OPTIONS = [
    {value: 'under_10k', label: 'Under $10k / mo'},
    {value: '10k_100k', label: '$10k – $100k / mo'},
    {value: '100k_1m', label: '$100k – $1M / mo'},
    {value: '1m_10m', label: '$1M – $10M / mo'},
    {value: 'over_10m', label: 'Over $10M / mo'},
]
